// extracted by mini-css-extract-plugin
export default {"popup":"TextOverflowPopup__popup-hT4vl","arrow":"TextOverflowPopup__arrow-bxJEA","popupContent":"TextOverflowPopup__popupContent-Ay9vb"};